import type { Transition } from 'framer-motion';

export const springs = {
  pop: { type: 'spring', stiffness: 460, damping: 22 } as Transition,
  bouncy: { type: 'spring', stiffness: 360, damping: 12, mass: 0.8 } as Transition,
  gentle: { type: 'spring', stiffness: 220, damping: 24 } as Transition,
  snappy: { type: 'spring', stiffness: 600, damping: 28 } as Transition,
  /** Big, playful overshoot. Use sparingly — landing screens, reveal
   *  moments, big-deal numbers. Lower damping = more bounce. */
  party: { type: 'spring', stiffness: 320, damping: 8, mass: 1 } as Transition,
};

/**
 * Idle-attention animation tuples. Wire these into framer-motion's
 * `animate={...}` to draw the eye to an interactive element without
 * being obnoxious about it.
 *
 *   wiggle    — gentle rotate sway. Use on primary CTAs (Next, Submit)
 *               between rounds so the player notices the next action.
 *   bobble    — slow vertical bob. Use on hint avatars / coaches.
 *   sparkle   — scale 1 → 1.06 → 1 ping. Use on score badges right
 *               after a points award.
 *
 * Each is paired with a reasonable `transition` you can spread into
 * the call site; bring your own override if you need different timing.
 */
export const idleAnim = {
  wiggle: {
    keyframes: { rotate: [0, -3, 3, -2, 2, 0] },
    transition: {
      duration: 1.8,
      repeat: Number.POSITIVE_INFINITY,
      repeatDelay: 2.4,
      ease: 'easeInOut',
    } as Transition,
  },
  bobble: {
    keyframes: { y: [0, -4, 0] },
    transition: {
      duration: 1.6,
      repeat: Number.POSITIVE_INFINITY,
      ease: 'easeInOut',
    } as Transition,
  },
  sparkle: {
    keyframes: { scale: [1, 1.08, 1] },
    transition: {
      duration: 0.6,
      repeat: 2,
      ease: 'easeInOut',
    } as Transition,
  },
};

export function vibrate(pattern: number | number[] = 10) {
  if (typeof window === 'undefined') return;
  const nav = window.navigator as Navigator & { vibrate?: (p: number | number[]) => boolean };
  nav.vibrate?.(pattern);
}
